<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <HomeHeroBar
          :section="'home4'"
          @gradientButtonClicked="scrollToEstateCostCalculator"
        />
      </template>
      <template v-slot:info-tiles>
        <div class="section-padding">
          <InfoTilesContainer
            :tiles="infoTiles"
            :buttonText="'CALCULATE MY COSTS'"
            @gradientButtonClicked="scrollToEstateCostCalculator"
            :alternativeTitle="`<span style='
              font-size: 28px;
              font-weight: 500;
              line-height: 34px;
              letter-spacing: -0.0025em;
              text-align: center;'>Protect your legacy. Estate costs affect everybody.</span> Plan ahead to protect their inheritance.
              <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>
              When you pass away, your loved ones could face unexpected estate costs and taxes such as:</p>`"
            :additionalText="`  <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>Without a plan, these costs can force the sale of assets — <span style='font-family: Montserrat;
              font-weight: 600;
              font-style: SemiBold;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              '>even your family home.</span></p>`"
          />
        </div>
      </template>
      <template v-slot:estate-cost-calculator>
        <div class="section-padding" ref="estateCostCalculatorSection">
          <TitleRow
            :html="true"
            :title="`<p style='
              font-weight: 300;
              font-size: 28px;
              line-height: 34px;
              letter-spacing: -0.25%;
              text-align: center;
              margin-bottom:0;
            '>
           Estate Administration Cost Calculator
            </p>`"
            :description="`<p style='
              font-weight: 400;
              font-size: 22px;
              line-height: 28px;
              text-align: center;
            '>
            Along with the heartache of death comes the additional burden of legal and administration fees. 
            It is important to <span style='
            font-weight: 600;
            '>
            plan for these costs</span> 
            so it does not cause stress for your loved ones at a time of grieving.
            </p>`"
          />
          <EstateCostCalculator
            :customButton="true"
            :customButtonText="'CREATE MY WILL'"
          />
        </div>
      </template>
      <template v-slot:info-title-row>
        <TitleRow
          :html="true"
          :title="`<p style='
                    font-weight: 400;
                    font-style: Regular;
                    font-size: 22px;
                    line-height: 28px;
                    letter-spacing: 0%;
                    text-align: center;
                    color: #1E1E1E;
                    '>
                    These are some of the costs your family may face.
                    <span style='
                    font-weight: 600;
                    font-style: SemiBold;
                    font-size: 22px;
                    line-height: 28px;
                    letter-spacing: 0%;
                    text-align: center;
                    '>
                    Without planning, they will be deducted from your estate
                    </span> 
                    before inheritance is paid your loved ones.</p>`"
          :description="''"
        />
      </template>
      <template v-slot:why-choose-us>
        <div class="section-padding">
          <ImageTextBanner
            :imageUrl="whitelabel.images.home4ReduceCostsImage"
            :title="'How to reduce these costs and plan their future'"
            :paragraphOne="`<p style='
                font-weight: 400;
                font-style: Regular;
                font-size: 16px;
                line-height: 28px;
                letter-spacing: 0%;
                color:#282828;
                '>
            Planning for these costs is done through an estate plan and documented in your will.</p>
            <p>By creating your will, you:</p>
            <ul class='list-disc'
            style='line-height: 28px;'
            >
              <li>Ensure your wishes are legally documented and followed</li>
              <li>Appoint an executor to wind up your estate</li>
              <li>Protect and provide for minor children</li>
              <li>Potentially reduce the amount to be paid on taxes and estate administration costs</li>
            </ul>
            <p style='
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: 0%;
            color:#282828;
            margin-top:24px;
            '>
            It takes less than 25 minutes to create your free, valid will online with Old Mutual.
            </p>
`"
            :reversed="true"
            :buttonText="'CREATE MY WILL'"
            @gradientButtonClicked="createYourWill"
            :bottomMargin="true"
          />
        </div>
      </template>
      <template v-slot:create-your-will-info>
        <div class="section-padding">
          <InfoTilesContainer
            :tiles="infoTilesCreateYourWill"
            :buttonText="'CREATE MY FREE WILL'"
            @gradientButtonClicked="createYourWill"
            :alternativeTitle="`<p style='
              font-weight: 500;
              font-size: 28px;
              line-height: 32px;
              letter-spacing: -0.23px;
              text-align: center;
            '>
            How to create a will with Old Mutual
            </p>
            <p style='
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            color:#747474;
            margin-bottom:48px;
            '>
            With Old Mutual you can create your legally valid will online in as little as 25 minutes.
            </p>`"
            :additionalText="`
            <p style='
            font-weight: 400;
            font-style: Regular;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            color:#747474;
            '>
            When you create your will, <span
            style='font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>
          you also get access to EstateAssist</span> — personalised
            insurance cover that <span style='
            font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>shields your loved ones from costly estate 
            fees and taxes.</span>
            </p>
            `"
          />
        </div>
      </template>
      <template v-slot:create-your-will-banner>
        <div class="section-padding">
          <CreateYourWillBanner
            :alternativeBanner="true"
            :bannerText="`<p style='
              font-weight: 600;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>Join 23,000+ South Africans 
            <span style='
              font-weight: 300;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>who’ve created their wills online with Old Mutual since 2023</span>
            </p>`"
            :pb0="true"
          />
        </div>
      </template>
      <template v-slot:take-control>
        <div class="section-padding">
          <ImageTextBanner
            :imageUrl="whitelabel.images.home1JoinUsImage"
            :title="`<p style='
                font-weight: 600;
                font-size: 28px;
                line-height: 36px;
                color:#282828;
                '>
                You’ve seen the costs. Now take control and plan for it.
                </p>`"
            :paragraphOne="`
            <p style='
            font-weight: 300;
            font-size: 28px;
            line-height: 36px;
              color:#282828;
            '>
            Don’t let estate costs and taxes take away your family’s inheritance. Protect your family and your wishes today.
            </p>`"
            :reversed="true"
            :buttonText="'CREATE MY WILL'"
            @gradientButtonClicked="createYourWill"
            :bottomMargin="true"
          />
        </div>
      </template>
      <template v-slot:callusback>
        <EstateAdministrationCostCalculatorFooter
          @requestACall="requestACall"
          v-if="whitelabel.brand !== 'quickwill'"
        />
      </template>
    </Layout>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
    <RequestACallDialog
      :showRequestACallDialog.sync="showRequestACallDialog"
      @success="showSuccessMessage"
    />
  </div>
</template>

<script>
  import HomeHeroBar from './HomeHeroBar.vue';
  import ButtonTilesContainer from '../ButtonTilesContainer.vue';
  import InfoTilesContainer from '../InfoTilesContainer.vue';
  import CreateYourWillBanner from '../CreateYourWillBanner.vue';
  import ImageTextBanner from '../ImageTextBanner.vue';
  import TestimonialsSection from '../TestimonialsSection.vue';
  import HR from '../../common/HR.vue';
  import Layout from '../../common/layouts/Layout.vue';
  import DynamicNavDrawer from '../../guest/DynamicNavDrawer.vue';
  import DrawerSignUp from '../../guest/DrawerSignUp.vue';
  import DrawerSignIn from '../../guest/DrawerSignIn.vue';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';
  import EstateAdministrationCostCalculatorFooter from '../EstateCostCalculator/EstateAdministrationCostCalculatorFooter.vue';
  import RequestACallDialog from '../dialogs/RequestACallDialog.vue';
  import Accordion from '../../common/Accordion.vue';
  import TitleRow from '../../common/TitleRow.vue';
  import EstateCostCalculator from '../calculators/estate_cost_calculator/EstateCostCalculator.vue';

  export default {
    name: 'Home4',
    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.homepage,
          },
        ],
      };
    },
    props: {
      openSignupDrawerImmediately: {
        required: false,
        default: false,
        type: Boolean,
      },
      isReferralLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isActivationLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isPasswordResetLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      verifyUserLinkCode: {
        required: false,
        default: null,
        type: Object,
      },
    },
    components: {
      HomeHeroBar,
      ButtonTilesContainer,
      InfoTilesContainer,
      CreateYourWillBanner,
      ImageTextBanner,
      TestimonialsSection,
      DynamicNavDrawer,
      HR,
      Layout,
      DrawerSignUp,
      DrawerSignIn,
      SuccessSnackbar,
      EstateAdministrationCostCalculatorFooter,
      RequestACallDialog,
      Accordion,
      TitleRow,
      EstateCostCalculator,
    },
    data(props) {
      return {
        signUpDrawerOpen: props.openSignupDrawerImmediately,
        signInDrawerOpen: false,
        showAlert: false,
        alertMessage: null,
        countryPattern: require('@/assets/shared/redesign/backgrounds/country-pattern.svg'),
        greenAccentOne: require('@/assets/shared/redesign/backgrounds/green-accent-1.svg'),
        greenAccentTwo: require('@/assets/shared/redesign/backgrounds/green-accent-2.svg'),
        purpleAccent: require('@/assets/shared/redesign/backgrounds/purple-accent.svg'),
        tribalPattern: require(`@/assets/old_mutual/homepage/generic.svg`),
        showRequestACallDialog: false,
      };
    },
    mounted() {
      if (localStorage.getItem('isLandingSimple')) {
        localStorage.removeItem('isLandingSimple');
        location.reload();
      }
    },
    methods: {
      successResetPassword() {
        this.signInDrawerOpen = false;
        this.alertMessage =
          this.whitelabel.authentication.resetPassword.successMessage;
        this.showAlert = true;
      },
      loginClicked() {
        this.signUpDrawerOpen = false;
        this.signInDrawerOpen = true;
      },
      calculateCostsClicked() {
        this.$router.push('/estate-administration-cost-calculator');
      },
      drawerClosed() {
        this.signUpDrawerOpen = false;
      },
      signInDrawerClosed() {
        this.signInDrawerOpen = false;
      },
      quickStartCardLinkClicked(routeName) {
        if (routeName === 'SignUpPage') {
          this.signUpDrawerOpen = true;
        } else {
          this.$router.push({ name: routeName });
        }
      },
      createYourWill() {
        this.$router.push('/register');
      },
      estateCostCalculator() {
        this.$router.push({
          name: 'EstateAdministrationCostCalculator',
        });
      },
      requestACall() {
        this.showRequestACallDialog = true;
      },
      showSuccessMessage(success) {
        this.$emit('success', success);
      },
      scrollToEstateCostCalculator() {
        if (this.$refs.estateCostCalculatorSection) {
          this.$refs.estateCostCalculatorSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      },
    },
    computed: {
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'info-tiles',
            hr: true,
            fadedRow: true,
            background: 'countryPattern',
          },
          {
            name: 'estate-cost-calculator',
          },
          {
            name: 'info-title-row',
            hr: true,
          },
          {
            name: 'why-choose-us',
            hr: true,
          },
          {
            name: 'create-your-will-info',
          },
          {
            name: 'create-your-will-banner',
          },
          {
            name: 'take-control',
          },
          {
            name: 'callusback',
          },
        ];
      },
      buttonTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.home1ButtonTileOne,
            title: '',
            description: `Answer a few guided questions`,
          },
          {
            imageUrl: this.whitelabel.images.home1ButtonTileTwo,
            title: '',
            description: `Review your personalised will`,
          },
          {
            imageUrl: this.whitelabel.images.home1ButtonTileThree,
            title: '',
            description: `Print, sign and validate`,
          },
        ];
      },
      infoTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.home4InfoTitleOne,
            title: `Estate duty`,
            description: `A tax of up to 25% levied on estates valued above R3.5 million.`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleTwo,
            title: `Executor's fees`,
            description: `A fee of up to 3.5% of your estate value. Applied on estates valued above R250 000.`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleThree,
            title: `Conveyancing & admin costs`,
            description: `Legal and transfer fees for property and other assets.`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleFour,
            title: `Debt settlements`,
            description: `Debts such as credit cards and home loans need to be settled.`,
          },
        ];
      },
      infoTilesCreateYourWill() {
        return [
          {
            imageUrl: this.whitelabel.images.home4InfoTitleSix,
            title: `Answer a few guided questions`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleFive,
            title: `Review your personalised will`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleSeven,
            title: `Print, sign and validate`,
          },
        ];
      },
      accordionData() {
        return this.whitelabel.FAQs1;
      },
    },
  };
</script>
<style lang="scss" scoped>
  @media only screen and (min-width: 601px) and (max-width: 807px) {
    .mobile-padding-top {
      padding-top: 111px;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 600px) {
    .mobile-padding-top {
      padding-top: 133px;
    }
  }
</style>
